import { createSlice } from "@reduxjs/toolkit";
import { dispatchStorage } from "../../util/common";

const userSlice = createSlice({
  name: "user",
  initialState: {
    details: {}
  },
  reducers: {
    saveUser: (state, action) => {
      const payload = action.payload || {};
      state.details = {
        id: payload.id || payload.userId,
        title: payload.title,
        firstName: payload.firstName,
        lastName: payload.lastName,
        mobilePhone: payload.mobilePhone || payload.phoneNumber,
        username: payload.username,
        email: payload.email,
        contactPreference: payload.contactPreference,
        notifications: payload.notifications,
        canDeleteAccount: payload.canDeleteAccount
      };
    },
    logoutUser: (state) => {
      state.details = {};
      // deleteStorage("otp");
      dispatchStorage("token", "TEMP_TOKEN");
    }
  }
});

export const { saveUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;
